import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { FileLockProp, InvoiceBillCrdb, RelatedCrdbDefinition } from '../ifmsTypes';
import {AiHbl} from './AiHbl';
import { CrDbHd } from './CrDbHd';
import { appendLine } from '../util';
import { MblStatusViewModel } from './MblStatusViewModel';

export interface AiMblNewEvent {
    check: boolean,
    date: string|null,
    location: string,
}

export class AiMbl extends TrackableEntity {
    id: number = 0;
    refNo: string = '';
    agentRefNo: string = '';
    mawbNo: string = '';
    sMawbNo: string = '';
    manifestNo: string = '';
    fltNo: string = '';
    vesselFlag: string = '';
    country: string = '';
    agent: number = 0;
    carrier: number = 0;
    fLocation: number = 0;
    fLocationName: string = '';
    departureCode: string = '';
    lCode: string = '';
    loadingPort: string = '';
    dCode: string = '';
    departureName: string = '';
    discharge: string = '';
    etd: string | null = null;
    etdTime: string | null = null;
    eta: string | null = null;
    etaTime: string | null = null;
    storageDate: string | null = null;
    goDate: string | null = null;
    postDate: string | null = null;
    pkgs: number = 0;
    grossWeight: number = 0;
    lGrossWeight: number = 0;
    chgWeight: number = 0;
    lChgWeight: number = 0;
    ppcc: string = '';
    fileClosed: number = 0;
    isFileClosed: boolean = false;
    agentCreditHold: boolean = false;
    closedBy: string = '';
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    branch: string = '';
    cur1: string = '';
    cur2: string = '';
    exRate1: number = 0;
    exRate2: number = 0;
    completeBill: boolean = false;
    completeInvo: boolean = false;
    completeCrdb: boolean = false;
    firstCode: string = '';
    firstPort: string = '';
    firstPortETA: string | null = null;
    firstPortETATime: string | null = null;
    lastPort: string = '';
    toAgent: string = '';
    manifestfrom: string = '';
    directBL: boolean = false;
    profitShare: number = 0;
    line: string = '';
    confirmDate: string | null = null;
    shipmentType: string = '';
    agent2: number = 0;
    agent3: number = 0;
    msManId: string = '';
    operator: string = '';
    u1Id: string = '';
    u2Id: string = '';
    u1Date: string | null = null;
    u2Date: string | null = null;
    dutyCustomer: number = 0;
    dutyCustomerName: string = '';
    dutyAgent: number = 0;
    dutyAgentName: string = '';
    mblCustomer: number = 0;
    mblCustomerName: string = '';
    carrierName: string = '';
    agentName: string = '';
    agentName2: string = '';
    agentName3: string = '';
    blVendor: string = '';
    blVendorId: number = 0;
    dCodeName: string = '';
    fCodeName: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    pimsLinkUserId: string = '';
    agentPimsId: number = 0;
    aaid: number = 0;
    cfsLocation: string = '';
    cfsAddress: string = '';
    cfsContact: string = '';
    amsLinkUserId: string = '';
    amsLinkId: number = 0;
    amsLinkDate: string | null = null;
    hblCount: number = 0;
    confirmedBy: string = '';
    closeDate: string | null = null;
    pUnit: string = '';
    anSend: string | null = null;
    anSendBy: string = '';
    atmeSend: string | null = null;
    atmeSendBy: string = '';
    isCustomsRls: boolean = false;
    customsRls: string | null = null;
    customsRlsBy: string = '';
    isCustomsHold: boolean = false;
    customsHold: string | null = null;
    customsHoldBy: string = '';
    isCargoRls: boolean = false;
    cargoRls: string | null = null;
    cargoRlsBy: string = '';
    mblCustomer2: number = 0;
    mblCustomer2Name: string = '';
    commodity: string = '';
    pickupDate: string | null = null;
    pickupLoc: string = '';
    atd: string | null = null;
    atdLoc: string = '';
    customsRlsLoc: string = '';
    ata: string | null = null;
    ataLoc: string = '';
    delivery: string | null = null;
    delvLoc: string = '';
    deliveryBy: string = '';
    avail: string | null = null;
    availLoc: string = '';

    milestone: MblStatusViewModel|null = null;
    //airLineStatusSelectedIndex: number = 0;

    //Direct B/L
    shipper: number = 0;
    consignee: number = 0;
    notify: number = 0;
    broker: number = 0;
    sName : string = '';
    cName: string = '';
    nName: string= '';
    bName: string = '';
    shipperName: string = '';
    consigneeName: string = '';
    notifyName: string = '';
    brokerName: string = '';
    bTel: string = '';
    bFax: string = '';
    bContact: string= '';
    bEmail: string = '';
    finalDest2: string='';
    fEta2: string | null = null;
    amsblNo: string = '';
    opeartor: string = '';
    custRefNo: string='';
    itNo: string='';
    itDate: string|null = null;
    itPlace: string='';
    mark: string ='';
    description: string = '';
    multinameId: number = 0;
    projectNo: string = '';
    remark: string = '';
    iMemo: string = '';


    // HBL Total
    hPkgs: number = 0;
    hGross: number = 0;
    hlGross: number = 0;
    hChg: number = 0;
    hlChg: number = 0;
    statusInvo: string = '';
    statusBill: string = '';
    statusCrDb: string = '';
    
    hblList: AiHbl[] = [];

    //<save-sqlinfo: ISalesCostParent
    invoiceBill: InvoiceBillCrdb|null = null;
    readonlyCrdbLineItems?: Array<CrDbHd>|null = null;
    relatedCrdbDefinitions: Array<RelatedCrdbDefinition>|null = null;
    //save-sqlInfo>

    // new milestone timestamps - helpers for editing milestone (Dario)
    newEvents: Array<AiMblNewEvent> = [
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
    ];

    // events that have been interacted with
    toggledEvents: Array<number> = [];

    // UI Only
    carrierChanged: boolean = false;
    lockAgent1: boolean = false;

    static fileLockEnableProps: FileLockProp[] = [
        { key: 'agentRefNo', name: 'Agent Ref. #' },
        { key: 'fLocation', name: 'Freight Location' },
    ];

    get canChangeBranch():boolean {
        if (this.id <= 0) {
            return true;
        }

        const allowedStatuses = ['', 'E', 'D'];
        return allowedStatuses.includes(this.statusBill) &&
            allowedStatuses.includes(this.statusInvo) &&
            allowedStatuses.includes(this.statusCrDb) &&
            this.hblList.every(h => allowedStatuses.includes(h.statusBill) && allowedStatuses.includes(h.statusInvo) && allowedStatuses.includes(h.statusCrDb))
    };

    constructor(init?:Partial<AiMbl>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'dutyCustomerName', 'dutyAgentName', 'hblCount',
        'newEvents', 'toggledEvents',
        //<save-sqlinfo>
        'closeDate', 'invoiceBill', 'readonlyCrdbLineItems', 'milestone', 'canChangeBranch', 
        'hblList', 'carrierChanged', 'actClosed', 'actClosedBy', 'actCloseDate', 'confirmDate', 'confirmedBy');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();
    }

    isFileLockFor(propName: string) {
        return this.fileClosed > 0 && !AiMbl.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        const messageBase = appendLine("OP Close", "The following fields are editable only:\n")
        return appendLine(messageBase, AiMbl.fileLockEnableProps
            .map(x => x.name)
            .reduce((acc: string, x) => appendLine(acc, `${x}`), ""));
    }
    
    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return AiMbl.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AIMMAIN' }),
        'refNo': new DBMappingInfo({ field: 'F_RefNo', table: 'T_AIMMAIN' }),
        'agentRefNo': new DBMappingInfo({ field: 'F_AgentRefNo', table: 'T_AIMMAIN' }),
        'mawbNo': new DBMappingInfo({ field: 'F_MawbNo', table: 'T_AIMMAIN' }),
        'sMawbNo': new DBMappingInfo({ field: 'F_SMawbNo', table: 'T_AIMMAIN' }),
        'manifestNo': new DBMappingInfo({ field: 'F_ManifestNo', table: 'T_AIMMAIN' }),
        'fltNo': new DBMappingInfo({ field: 'F_FLTNo', table: 'T_AIMMAIN' }),
        'vesselFlag': new DBMappingInfo({ field: 'F_VesselFlag', table: 'T_AIMMAIN' }),
        'country': new DBMappingInfo({ field: 'F_Country', table: 'T_AIMMAIN' }),
        'agent': new DBMappingInfo({ field: 'F_Agent', table: 'T_AIMMAIN' }),
        'fLocation': new DBMappingInfo({ field: 'F_FLocation', table: 'T_AIMMAIN' }),
        'departureCode': new DBMappingInfo({ field: 'F_LCode', table: 'T_AIMMAIN' }),
        'dCode': new DBMappingInfo({ field: 'F_DCode', table: 'T_AIMMAIN' }),
        'departureName': new DBMappingInfo({ field: 'F_LoadingPort', table: 'T_AIMMAIN' }),
        'discharge': new DBMappingInfo({ field: 'F_Discharge', table: 'T_AIMMAIN' }),
        'etd': new DBMappingInfo({ field: 'F_ETD', table: 'T_AIMMAIN' }),
        'eta': new DBMappingInfo({ field: 'F_ETA', table: 'T_AIMMAIN' }),
        'storageDate': new DBMappingInfo({ field: 'F_StorageDate', table: 'T_AIMMAIN' }),
        'goDate': new DBMappingInfo({ field: 'F_GODate', table: 'T_AIMMAIN' }),
        'postDate': new DBMappingInfo({ field: 'F_PostDate', table: 'T_AIMMAIN' }),
        'pkgs': new DBMappingInfo({ field: 'F_Pkgs', table: 'T_AIMMAIN' }),
        'grossWeight': new DBMappingInfo({ field: 'F_GrossWeight', table: 'T_AIMMAIN' }),
        'lGrossWeight': new DBMappingInfo({ field: 'F_LGrossWeight', table: 'T_AIMMAIN' }),
        'chgWeight': new DBMappingInfo({ field: 'F_ChgWeight', table: 'T_AIMMAIN' }),
        'lChgWeight': new DBMappingInfo({ field: 'F_LChgWeight', table: 'T_AIMMAIN' }),
        'ppcc': new DBMappingInfo({ field: 'F_PPCC', table: 'T_AIMMAIN' }),
        'fileClosed': new DBMappingInfo({ field: 'F_FileClosed', table: 'T_AIMMAIN' }),
        'closedBy': new DBMappingInfo({ field: 'F_ClosedBy', table: 'T_AIMMAIN' }),
        'branch': new DBMappingInfo({ field: 'F_BRANCH', table: 'T_AIMMAIN' }),
        'cur1': new DBMappingInfo({ field: 'F_CUR1', table: 'T_AIMMAIN' }),
        'cur2': new DBMappingInfo({ field: 'F_CUR2', table: 'T_AIMMAIN' }),
        'exRate1': new DBMappingInfo({ field: 'F_EXRATE1', table: 'T_AIMMAIN' }),
        'exRate2': new DBMappingInfo({ field: 'F_EXRATE2', table: 'T_AIMMAIN' }),
        'completeBill': new DBMappingInfo({ field: 'F_CompleteBill', table: 'T_AIMMAIN' }),
        'completeInvo': new DBMappingInfo({ field: 'F_CompleteInvo', table: 'T_AIMMAIN' }),
        'completeCrdb': new DBMappingInfo({ field: 'F_CompleteCrDb', table: 'T_AIMMAIN' }),
        'firstCode': new DBMappingInfo({ field: 'F_FirstCode', table: 'T_AIMMAIN' }),
        'firstPort': new DBMappingInfo({ field: 'F_FirstPort', table: 'T_AIMMAIN' }),
        'firstPortETA': new DBMappingInfo({ field: 'F_FirstPortETA', table: 'T_AIMMAIN' }),
        'lastPort': new DBMappingInfo({ field: 'F_LastPort', table: 'T_AIMMAIN' }),
        'manifestfrom': new DBMappingInfo({ field: 'F_Manifestfrom', table: 'T_AIMMAIN' }),
        'toAgent': new DBMappingInfo({ field: 'F_TOAgent', table: 'T_AIMMAIN' }),
        'directBL': new DBMappingInfo({ field: 'F_directbl', table: 'T_AIMMAIN' }),
        'profitShare': new DBMappingInfo({ field: 'F_ProfitShare', table: 'T_AIMMAIN' }),
        'line': new DBMappingInfo({ field: 'F_Line', table: 'T_AIMMAIN' }),
        'shipmentType': new DBMappingInfo({ field: 'F_ShipmentType', table: 'T_AIMMAIN' }),
        'agent2': new DBMappingInfo({ field: 'F_Agent2', table: 'T_AIMMAIN' }),
        'agent3': new DBMappingInfo({ field: 'F_Agent3', table: 'T_AIMMAIN' }),
        'msManId': new DBMappingInfo({ field: 'F_MSManID', table: 'T_AIMMAIN' }),
        'dutyCustomer': new DBMappingInfo({ field: 'F_DutyCustomer', table: 'T_AIMMAIN' }),
        'dutyAgent': new DBMappingInfo({ field: 'F_DutyAgent', table: 'T_AIMMAIN' }),
        'mblCustomer': new DBMappingInfo({ field: 'F_MBLCustomer', table: 'T_AIMMAIN' }),
        'blVendorId': new DBMappingInfo({ field: 'F_Carrier', table: 'T_AIMMAIN' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_AIMMAIN' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_AIMMAIN' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_AIMMAIN' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_AIMMAIN' }),
        'pUnit': new DBMappingInfo({ field: 'PUnit', table: 'T_AIMMAIN' }),
        'anSend': new DBMappingInfo({ field: 'AnSend', table: 'T_AIMMAIN' }),
        'anSendBy': new DBMappingInfo({ field: 'AnSendBy', table: 'T_AIMMAIN' }),
        'atmeSend': new DBMappingInfo({ field: 'AtmeSend', table: 'T_AIMMAIN' }),
        'atmeSendBy': new DBMappingInfo({ field: 'AtmeSendBy', table: 'T_AIMMAIN' }),
        'isCustomsRls': new DBMappingInfo({ field: 'IsCustomsRls', table: 'T_AIMMAIN' }),
        'customsRls': new DBMappingInfo({ field: 'f_CustomRls', table: 'T_AIMMAIN' }),
        'customsRlsBy': new DBMappingInfo({ field: 'CustomsRlsBy', table: 'T_AIMMAIN' }),
        'isCustomsHold': new DBMappingInfo({ field: 'IsCustomsHold', table: 'T_AIMMAIN' }),
        'customsHold': new DBMappingInfo({ field: 'CustomsHold', table: 'T_AIMMAIN' }),
        'customsHoldBy': new DBMappingInfo({ field: 'CustomsHoldBy', table: 'T_AIMMAIN' }),
        'isCargoRls': new DBMappingInfo({ field: 'IsCargoRls', table: 'T_AIMMAIN' }),
        'cargoRls': new DBMappingInfo({ field: 'CargoRls', table: 'T_AIMMAIN' }),
        'cargoRlsBy': new DBMappingInfo({ field: 'CargoRlsBy', table: 'T_AIMMAIN' }),
        'mblCustomer2': new DBMappingInfo({ field: 'MblCustomer2', table: 'T_AIMMAIN' }),
        'commodity': new DBMappingInfo({ field: 'Commodity', table: 'T_AIMMAIN' }),
        'projectNo': new DBMappingInfo({ field: 'ProjectNo', table: 'T_AIMMAIN' }),
        'remark': new DBMappingInfo({ field: 'Remark', table: 'T_AIMMAIN' }),
        'iMemo': new DBMappingInfo({ field: 'F_IMemo', table: 'T_AIMMAIN' }),
        //airline status
        'pickupDate': new DBMappingInfo({ field: 'f_pickupdate', table: 'T_AIMMAIN' }),
        'pickupLoc': new DBMappingInfo({ field: 'f_pickuploc', table: 'T_AIMMAIN' }),
        'atd': new DBMappingInfo({ field: 'f_atd', table: 'T_AIMMAIN' }),
        'atdLoc': new DBMappingInfo({ field: 'f_atdloc', table: 'T_AIMMAIN' }),
        'customsRlsLoc': new DBMappingInfo({ field: 'f_custmrlsloc', table: 'T_AIMMAIN' }),
        'ata': new DBMappingInfo({ field: 'f_ata', table: 'T_AIMMAIN' }),
        'ataLoc': new DBMappingInfo({ field: 'f_ataloc', table: 'T_AIMMAIN' }),
        'avail': new DBMappingInfo({ field: 'f_avail', table: 'T_AIMMAIN' }),
        'availLoc': new DBMappingInfo({ field: 'f_availloc', table: 'T_AIMMAIN' }),
        'delivery': new DBMappingInfo({ field: 'f_delivery', table: 'T_AIMMAIN' }),
        'delvLoc': new DBMappingInfo({ field: 'f_delvloc', table: 'T_AIMMAIN' }),
        //'deliveryBy': new DBMappingInfo({ field: 'DeliveryBy', table: 'T_AIMMAIN' }),
        //Direct B/L
        'shipper': new DBMappingInfo({field:'f_mshipper', table: 'T_AIMMAIN'}),
        'consignee': new DBMappingInfo({field:'f_mconsignee', table: 'T_AIMMAIN'}),
        'notify': new DBMappingInfo({field:'f_mnotify', table: 'T_AIMMAIN'}),
        'broker': new DBMappingInfo({field:'f_mbroker', table: 'T_AIMMAIN'}),
        'sName': new DBMappingInfo({field:'f_msname', table: 'T_AIMMAIN'}),
        'cName': new DBMappingInfo({field:'f_mcname', table: 'T_AIMMAIN'}),
        'nName': new DBMappingInfo({field:'f_mnname', table: 'T_AIMMAIN'}),
        'bName': new DBMappingInfo({field:'f_mbname', table: 'T_AIMMAIN'}),
        'bTel': new DBMappingInfo({field:'f_mbtel', table: 'T_AIMMAIN'}),
        'bFax': new DBMappingInfo({field:'f_mbfax', table: 'T_AIMMAIN'}),
        'bContact': new DBMappingInfo({field:'f_mbcontact', table: 'T_AIMMAIN'}),
        'bEmail': new DBMappingInfo({field:'f_mbemail', table: 'T_AIMMAIN'}),
        'finalDest2': new DBMappingInfo({field:'f_mfinaldest', table: 'T_AIMMAIN'}),
        'fEta2': new DBMappingInfo({field:'f_mfeta', table: 'T_AIMMAIN'}),
        'amsblNo': new DBMappingInfo({field:'f_mamsblno', table: 'T_AIMMAIN'}),
        'operator': new DBMappingInfo({field:'f_operator', table: 'T_AIMMAIN'}),
        'custRefNo': new DBMappingInfo({field:'f_mcustrefno', table: 'T_AIMMAIN'}),
        'itNo': new DBMappingInfo({field:'f_mitno', table: 'T_AIMMAIN'}),
        'itDate': new DBMappingInfo({field:'f_mitdate', table: 'T_AIMMAIN'}),
        'itPlace': new DBMappingInfo({field:'f_mitplace', table: 'T_AIMMAIN'}),
        'mark': new DBMappingInfo({field:'f_mmark', table: 'T_AIMMAIN'}),
        'description': new DBMappingInfo({field:'f_mdescription', table: 'T_AIMMAIN'}),
        'multinameId': new DBMappingInfo({field:'f_mmultinameid', table: 'T_AIMMAIN'}),
    };

    hasNewEvents(): boolean {
        return this.toggledEvents.length > 0;
    }
}
